module.exports = __webpack_public_path__ + "static/media/TutorVid.a3173f91.mp4";